import { type DomainKeyEnum, useDomain } from "..";

interface DomainFieldProps {
    domainKey: DomainKeyEnum;
    value: any;
    inputProps?: any;
}

export function DomainField({ domainKey, value, inputProps }: DomainFieldProps): JSX.Element {
    const domain = useDomain(domainKey);

    const InputComponent = domain.InputComponent;

    if (!InputComponent) {
        console.error(`DomainField - InputComponent is not implemented in domain ${domainKey}`);
        return <div></div>;
    }

    return (
        <InputComponent
            value={value}
            {...domain.defaultInputProps}
            {...inputProps}
        ></InputComponent>
    );
}
